export default __webpack_public_path__ + "static/media/cash.0c0e22d2.png";